import { useEffect, useState } from 'react';

// Mirrors the current nav_menu_items seed data. Used as the instant first
// paint (so the nav isn't empty on load) and as a fallback if the API call
// fails; normally replaced by the fetched, dashboard-managed data.
const FALLBACK_ITEMS = [
  { menu_key: 'home', label: 'Home', link: '/', style: 'link', is_active: 1 },
  { menu_key: 'music', label: 'Music', link: '/music', style: 'link', is_active: 1 },
  { menu_key: 'invite', label: 'Invite', link: '/invite', style: 'link', is_active: 1 },
  { menu_key: 'testimonies', label: 'Testimonies', link: '/testimonial', style: 'link', is_active: 1 },
  { menu_key: 'join', label: 'Join Us', link: '/join', style: 'link', is_active: 0 },
  { menu_key: 'mentorship', label: 'Mentorship', link: '/Mentorship', style: 'link', is_active: 0 },
  { menu_key: 'events', label: 'Events', link: '/Events', style: 'link', is_active: 1 },
  { menu_key: 'volunteer', label: 'Become a Volunteer', link: '/support', style: 'link', is_active: 1 },
  { menu_key: 'donate', label: 'Support', link: '/donation', style: 'cta', is_active: 1 },
];

// Returns the active nav links and the (optional) CTA button, driven by the
// dashboard-managed menu. Falls back to the current defaults if the API is
// unreachable so the nav never ends up empty.
const useNavMenu = () => {
  const [items, setItems] = useState(FALLBACK_ITEMS);

  useEffect(() => {
    let cancelled = false;
    fetch(`${process.env.REACT_APP_BASE_URL}/api/nav-menu`)
      .then((res) => res.json())
      .then((data) => {
        if (!cancelled && Array.isArray(data.items) && data.items.length > 0) {
          setItems(data.items);
        }
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  const active = items.filter((i) => i.is_active);
  return {
    links: active.filter((i) => i.style !== 'cta'),
    cta: active.find((i) => i.style === 'cta') || null,
  };
};

export default useNavMenu;
